<template>
  <div class="summary">
    <div class="scroll-content">
      <div class="summary-info">
        <div class="ship-info">
          <div class="ship-info-left">
            <Icon
              class="ship-info-left__icon"
              name="global-delivery-l"
            />
            <div class="text">
              Shipping to
            </div>
          </div>
          <div class="ship-info-right">
            <Popover
              @show="arrowRotate = true"
              @hide="arrowRotate = false"
              placement="bottom"
              trigger="click"
            >
              <template #reference>
                <div class="ship-main">
                  <img
                    class="ship-main-img"
                    :src="ship.country.countryUrl"
                  >
                  <span class="ship-main-title">{{ ship.country.countryName }}</span>
                  <Icon
                    class="icon"
                    :class="{ 'rotate-180': arrowRotate }"
                    name="arrow-down-l-2"
                  />
                </div>
              </template>
              <ShipTo
                :current-country="ship.country"
              />
            </Popover>
          </div>
        </div>
        <div class="line" />
        <div class="fulfillment">
          Fulfillment Supplier
        </div>
        <div class="bd">
          <img
            src="@/assets/images/bd-logo.svg"
            alt=""
          >
          <div class="bd-partner">
            Pro international fulfillment
          </div>
        </div>
        <div class="est-delivery-time">
          Estimated Delivery Time: <span class="suffix">{{ minDeliveryTime }} - {{ maxDeliveryTime }}</span> days
        </div>
        <div class="est-info">
          <div class="est-info_total-cost">
            {{ shippingConfirmed ? 'Total Cost' : 'Est.Total Cost' }}
          </div>
          <div class="est-info_total-items">
            <div>Total Items ({{ estimatedQuantity }})</div>
            <div v-if="totalItemsAmount">
              <IntlCurrency :currency="currencyData?.targetCurrency" />
              {{ totalItemsAmount.toFixed(2) }}
            </div>
            <div v-else>
              --
            </div>
          </div>
          <div class="est-info_shipping">
            <div class="est-info_shipping_left">
              {{ shippingConfirmed ? 'Shipping Cost' : 'Est.Shipping' }}
              <Tooltip :offset="4">
                <template #content>
                  The length, width, height and weight are calculated by predicting the average value of similar products. The price will be verified again after adding it to the shopping cart. Please wait patiently.
                </template>
                <Icon
                  v-if="!shippingConfirmed"
                  name="icon-help-tip-l"
                />
              </Tooltip>
            </div>
            <div
              v-if="totalItemsAmount && Number(shipAmount) === 0"
              class="free-shipping"
            >
              Free Shipping
            </div>
            <div v-else>
              <template v-if="!shippingConfirmed">
                Need a Quote
              </template>
              <template v-else-if="shipAmount">
                <IntlCurrency :currency="currencyData?.targetCurrency" />
                {{ shipAmount.toFixed(2) }}
              </template>
              <template v-else>
                --
              </template>
            </div>
          </div>
          <div class="est-info_total-price">
            <div class="price">
              <IntlCurrency :currency="currencyData?.targetCurrency" />{{ totalAmount.toFixed(2) }}
            </div>
          </div>
          <div class="est-info_sub-price">
            <div class="ful-price">
              {{ shippingConfirmed ? 'Per-Item Fulfillment Price' : 'Est.Per-Item Fulfillment Price' }}
            </div>
            <div
              v-if="pifpPrice"
              class="piece-price"
            >
              <IntlCurrency :currency="currencyData?.targetCurrency" />{{ pifpPrice }}
            </div>
            <div v-else>
              --
            </div>
          </div>
        </div>
        <div class="summary__buttons">
          <Button
            v-if="hasBoundStore"
            @click="() => onDropshipping(offerId)"
            class="button"
            type="primary"
          >
            {{ shippingConfirmed ? 'Push' : 'Quote & Push' }}
          </Button>
          <Button
            v-else-if="orderEnable"
            @click="handleGetQuote"
            class="button"
            type="primary"
          >
            Get a Quote
          </Button>
          <Button
            v-else
            @click="applyOrder"
            :class="{ 'enable-order-function': userStore.userInfo.tk }"
            class="button"
            type="primary"
          >
            Start Order
          </Button>
        </div>
        <div
          v-if="hasProcessing"
          class="processing-tip"
        >
          <img
            class="processing-tip-icon"
            src="@/assets/images/warning.svg"
            alt=""
          >
          <div class="text">
            Your request will be processed within 1 business day. Note: Some items may face customs restrictions in your country. We're verifying clearance status. While waiting, consult our category experts free of charge.
          </div>
          <div
            @click.stop="contactUs"
            class="contact-us"
          >
            Free Expert Consultation Now!
          </div>
        </div>
        <div class="payment-support">
          <img
            class="payment-support-icon"
            src="@/assets/offer/bank-card.svg"
            alt=""
          >
          <div class="right-info">
            <div class="title">
              Payment methods:
            </div>
            <div class="with-support">
              with
              <img
                src="@/assets/illus/illus-paypal.svg"
                alt=""
              >
              or
              <span>&nbsp;Bank Transfer</span>
            </div>
          </div>
        </div>
      </div>
      <div class="security-info">
        <div class="buyee-guarantee">
          <div class="shopping-security">
            <img
              src="@/assets/illus/illus-guarantee.svg"
              alt=""
            >
            <div class="title">
              Buyer Guarantee ·
              <span>Shopping Security</span>
            </div>
          </div>
          <div class="item">
            <img
              src="@/assets/offer/buyer-guarantee-logo1.svg"
              alt=""
            >
            <div class="right-info">
              <div class="header">
                Secure Payments
              </div>
              <div class="content">
                Every payment you make on Bestdealer is secured with strict SSL encryption and PCI DSS data protection protocols.
              </div>
            </div>
          </div>
          <div class="line" />
          <div class="item">
            <img
              src="@/assets/offer/buyer-guarantee-logo2.svg"
              alt=""
            >
            <div class="right-info">
              <div class="header">
                Standard Refund Policy
              </div>
              <div class="content">
                If your order hasn’t shipped, is missing, or has product issues, Please contact us proactively to request a refund.
              </div>
            </div>
          </div>
          <div class="line" />
          <div class="item">
            <img
              src="@/assets/illus/illus-privacy.svg"
              alt=""
            >
            <div class="right-info">
              <div class="header">
                Privacy Protection
              </div>
              <div class="content">
                We are committed to protecting it through maintaining industry-standard physical, technical, and administrative measures designed to guard your personal data from unauthorized processing, use or disclosure.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRoute } from 'vue-router'
import { buriedPointUtil } from '@/utils/utils'
import { useUserStore } from '@/pinia/user'
import { useLoginModal } from '@/components/Login'
import { useContactApp } from '@/hooks/useContactApp'
import Icon from '@/components/Icon/Icon.vue'
import Popover from '@/components/Popover/index.vue'
import ShipTo from './ShipTo.vue'
import Tooltip from '@/components/Tooltip/index.vue'
import { IntlCurrency } from '@/components/NewIntlCurrency'
import { useCurrencyStore } from '@/pinia/currency'
import { useShipStore } from '@/pinia/ship'
import { useOrderEnable } from '@/views/OfferView/components/hooks/useOrderEnable'
import { useCalcShip } from '@/views/OfferView/components/hooks/useCalcShip'
import { Button } from '@/components/Button'
import { useDropshipping } from '@/components/Dropshipping/useDropshipping'
import { useGetQuote } from '@/hooks/useGetQuote'

defineProps({
  hasProcessing: {
    type: Boolean,
    default: false
  },
  minOrderQuantity: {
    type: Number,
    default: 0
  }
})

const { hasBoundStore, onDropshipping } = useDropshipping()

const { enable: orderEnable } = useOrderEnable()

const { shippingConfirmed } = useCalcShip()

const currencyStore = useCurrencyStore()

const userStore = useUserStore()

const ship = useShipStore()

const route = useRoute()

const { open: openLoginModal } = useLoginModal()

const { contactUs } = useContactApp()

const { openGetQuote } = useGetQuote()

const arrowRotate = ref(false)

const { selectedSkuList, shipAmount, totalItemsAmount, totalAmount, minDeliveryTime, maxDeliveryTime } = useCalcShip()

const offerId = computed(() => route.params.id)

const currencyData = computed(() => currencyStore.current)

const estimatedQuantity = computed(() => {
  if (selectedSkuList.value.length === 0) return 0
  return selectedSkuList.value.reduce((pre, cur) => {
    return pre + cur.quantity
  }, 0)
})

const pifpPrice = computed(() => {
  if (!totalAmount.value) return 0

  const val = (totalItemsAmount.value + shipAmount.value) / estimatedQuantity.value
  return val.toFixed(2)
})

const handleGetQuote = () => {
  buriedPointUtil({ eventId: 'PPD209' })
  openGetQuote()
}

const applyOrder = () => {
  buriedPointUtil({ eventId: 'PPD221' })
  if (!userStore.userInfo.tk) {
    openLoginModal()
  }
}

</script>

<style lang='less' scoped>
.summary {
  position: sticky;
  top: 24px;
  background-color: #F8F8F8;
  border-radius: 8px;
  padding: 8px 0;
  transition: top .3s;

  .scroll-content {
    max-height: calc(100vh - 48px);
    overflow-y: scroll;
    &::-webkit-scrollbar {
      /* 隐藏默认的滚动条 */
      scrollbar-width: none;
      -webkit-appearance: none;
    }
  }

  .summary-info {
    padding: 12px 16px 16px;

    .ship-info {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 20px;
      .ship-info-left {
        display: flex;
        align-items: center;
        gap: 6px;

        &__icon {
          font-size: 20px;
        }

        .text {
          color: #232323;
          font-size: 12px;
          font-family: mon-600;
        }
      }
      .ship-info-right {
        display: flex;
        align-items: center;
        cursor: pointer;
        .ship-main {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 4px;
          .ship-main-img {
            width: 16px;
            height: 16px;
            object-fit: contain;
          }
          .ship-main-title {
            color: #232323;
            font-size: 12px;
            font-family: mon-600;
          }
          .icon {
            transition: transform .3s ease-in-out;
            &.rotate-180 {
              transform: rotate(180deg);
            }
          }
        }
      }
    }

    .line {
      margin: 16px 0px;
      height: 1px;
      background-color: #dfdfdf;
    }

    .fulfillment {
      font-family: mon-700;
      font-size: 14px;
      line-height: 18px;
      color: #232323;
    }
    .bd {
      display: flex;
      margin-top: 8px;
      gap: 4px;
      img {
        width: 98px;
      }
      .bd-partner {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 6px;
        height: 18px;
        border-radius: 4px;
        background-color: #DFE8FB;
        color: #232323;
        font-size: 10px;
        font-family: mon-600;
        white-space: nowrap;
      }
    }
    .est-delivery-time {
      margin-top: 4px;
      color: #232323;
      font-size: 11px;
      font-family: mon-500;
      .suffix {
        font-family: mon-700;
        color: #529426;
      }
    }
    .est-info {
      margin-top: 16px;
      &_total-cost {
        color: #232323;
        font-size: 14px;
        font-family: mon-700;
        line-height: 18px;
      }
      &_total-items {
        margin-top: 8px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #232323;
        font-size: 12px;
        font-family: mon-600;
        line-height: 16px;
      }
      &_shipping {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 6px;
        color: #232323;
        font-size: 12px;
        font-family: mon-600;
        line-height: 16px;
        .est-info_shipping_left {
          cursor: pointer;
          display: flex;
          align-items: center;
          .tooltip-wrapper {
            display: flex;
            padding-left: 2px;
          }
        }
      }
      &_total-price {
        margin-top: 8px;
        display: flex;
        gap: 6px;
        .price {
          color: #052784;
          font-size: 24px;
          font-family: mon-700;
          white-space: nowrap;
        }
      }
      &_sub-price {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #168A73;
        font-size: 11px;
        font-family: mon-600;
        .ful-price {
          margin-top: 2px;
          .icon {
            color: #232323;
            cursor: pointer;
          }
        }
      }
    }
    .button {
      gap: 4px;
      height: 40px;
    }

    .processing-tip {
      width: 254px;
      background-color: #eff4fd;
      border-radius: 8px;
      margin: 12px auto 16px;
      padding: 12px;

      .processing-tip-icon {
        position: relative;
        top: -4px;
      }

      .text {
        color: #232323;
        font-size: 10px;
        font-family: mon-500;
        line-height: 14px;
      }

      .contact-us {
        color: #232323;
        font-size: 10px;
        font-family: mon-600;
        line-height: 14px;
        margin-top: 6px;
        text-decoration: underline;
        cursor: pointer;
      }
    }
    .payment-support {
      display: flex;
      align-items: flex-start;
      margin-top: 16px;
      .payment-support-icon {
        margin-right: 8px;
        position: relative;
        bottom: 2px;
      }
      .right-info {
        .title {
          font-size: 12px;
          font-family: mon-600;
          color: #232323;
          line-height: 16px;
        }
        .with-support {
          margin-top: 2px;
          display: flex;
          align-items: center;
          color: #232323;
          font-size: 11px;
          font-family: mon-500;
          span {
            font-family: mon-700;
          }
        }
      }
    }
  }
  .security-info {
    .buyee-guarantee {
      padding-bottom: 12px;
      .shopping-security {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 8px;
        padding: 4px 12px;
        height: 48px;
        background: linear-gradient(#CDD8F7, #F8F8F8);
        .title {
          color: #232323;
          font-size: 12px;
          font-family: mon-700;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          span {
            font-family: mon-600;
          }
        }
      }
      .item {
        display: flex;
        align-items: center;
        gap: 16px;
        padding: 0 16px;
        > img {
          width: 40px;
          height: 40px;
        }
        .right-info {
          .header {
            color: #052784;
            font-size: 12px;
            font-family: mon-600;
          }
          .content {
            margin-top: 4px;
            font-size: 10px;
            color: #232323;
            font-family: mon-500;
            line-height: 14px;
          }
        }
      }
      .line {
        position: relative;
        left: 72px;
        width: 198px;
        margin: 16px 0;
        background-color: #dfe8e8;
        height: 1px;
      }
    }
  }

  &__buttons {
    margin-top: 16px;
  }

  &__discount {
    margin-bottom: 8px;
  }
}
</style>
